<div *ngIf="!auth.authenticated">

  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />

  <div class="home">
    <h1>Please <a (click)="auth.signIn()" [routerLink]="">sign in</a> to continue.</h1>
  </div>

  <br />
  <br />
  <br />
  <br />

  <div class="home">
    <img class="logo" src="assets/CollectorAssistantToolLogoNavy.png" />
  </div>

</div>

<div *ngIf="auth.authenticated">

  <h2>
    Collector Assistant Tool (Homepage)
  </h2>
  <h3>
    Developed by GLS to enhance collections capabilities. This service supplements representatives in:
  </h3>

  <ul style="font-size:20px">
    <li>
      Managing numerous account portfolios
    </li>
    <li>
      Contacting customers to determine intent to pay and ability to resolve delinquency
    </li>
    <li>
      Meeting/exceeding assigned business plan objectives
    </li>
    <li>
      Aiding clients by offering solutions based on individual needs
    </li>
    <li>
      Documenting systems with details of current contacts and subsequent results
    </li>

  </ul>

  <div class="home">
    <img class="logo" src="assets/CollectorAssistantToolLogoNavy.png" />
  </div>


  <br />
  <br />
  <br />
  <br />

  <h4><a [routerLink]='["/midstage-accounts"]'>Mid-Stage Accounts:</a> Optimizes the daily workflow providing relevant information for each account in the queue, ordered in priority order.</h4>
  <h4><a [routerLink]='["/deactivated-numbers"]'>Deactivated Numbers:</a> Establishes a worklist of phone numbers received daily from SBT's API with the associated account number(s).</h4>
  <h4><a [routerLink]='["/text-replies"]'>Text Replies:</a> Generates a worklist of customer replies from our text campaigns with insights on when an agent works a reply.</h4>
  <h4><a [routerLink]='["/email-replies"]'>Email Replies:</a> Generates a worklist of customer replies from our email campaigns with insights on when an agent works a reply.</h4>
  <h4><a [routerLink]='["/reference-automation-exceptions"]'>Reference Exceptions:</a> Displays the exception report of automated addition of references from Defi to V8 after a loan is booked.</h4>

  <br />
  <br />
  <br />

  <h3>
    <b>
      Please select a tab (left) or hyperlink (above)
    </b>
  </h3>

</div>










// WEBPACK FOOTER //
// ./src/app/home/home.component.html